import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule, SharedLegModule } from '@approot/shared';
import { WidgetsModule } from '@approot/widgets/widgets.module';
import { RfqModule } from '@approot/widgets/rfq/rfq.module';
import { ProviderQuoteContainerComponent } from './provider-quote-container/provider-quote-container.component';
import { ProviderQuoteTabComponent } from './provider-quote-tab/provider-quote-tab.component';
import { ProviderQuotePricesComponent } from './provider-quote-prices/provider-quote-prices.component';
import { ProviderQuoteSetupComponent } from './provider-quote-setup/provider-quote-setup.component';
import { ProviderRfqsComponent } from './provider-rfqs/provider-rfqs.component';
import { SafeNumberPipe } from './safe-number.pipe';
import { ProviderMultiHedgeComponent } from './provider-multi-hedge/provider-multi-hedge.component';
import { ProviderMultiHedgeGroupComponent } from './provider-multi-hedge-group/provider-multi-hedge-group.component';
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SharedLegModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetsModule,
    RfqModule,
    AgGridModule
  ],
  declarations: [
    ProviderQuoteContainerComponent,
    ProviderQuoteTabComponent,
    ProviderQuotePricesComponent,
    ProviderQuoteTabComponent,
    ProviderQuoteSetupComponent,
    ProviderRfqsComponent,
    ProviderMultiHedgeComponent,
    ProviderMultiHedgeGroupComponent,
    SafeNumberPipe
  ],
  exports: [ProviderQuoteContainerComponent, ProviderRfqsComponent]
})
export class ProviderQuoteModule {}
